/* this file is transformed by vux-loader */
/* eslint-disable */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    verifyShow: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    orderBalance: {
      type: String,
      default: function _default() {
        return '';
      }
    }
  },
  data: function data() {
    return {};
  },
  methods: {
    cancle: function cancle() {
      this.$emit('closeConfirm');
    },
    confirmOrderMeal: function confirmOrderMeal() {
      console.log("1111111111111111");
      this.$parent.baoting();
    }
  },
  created: function created() {},
  mounted: function mounted() {}
};